export const gzipToBase64 = async (text: string): Promise<string> => {
    const bytes = new TextEncoder().encode(text);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cs = new (window as any).CompressionStream('gzip');
    const writer = cs.writable.getWriter();
    writer.write(bytes);
    writer.close();
    const buffer: ArrayBuffer = await new Response(cs.readable).arrayBuffer();
    const compressed = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < compressed.byteLength; i++) {
      binary += String.fromCharCode(compressed[i]);
    }
    return btoa(binary);
  };
